// Simple distance conversion utilities
export const convertDistance = (meters) => {
  if (!meters) return 0;
  return (meters / 1000).toFixed(2);
};

export const getUnitLabel = () => {
  return 'km';
};
